import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Download } from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNotifications } from '../../../common/hooks/useNotifications';

export const CaDownloadButton: React.FC = () => {
  const spd = useSpdCore();
  const notifications = useNotifications();
  const [isDownloadingCa, setIsDownloadingCa] = useState(false);

  const handleDownloadCa = async () => {
    try {
      setIsDownloadingCa(true);
      await spd.certificates.downloadRootCa();
      notifications.onPromise(Promise.resolve());
    } catch (error) {
      notifications.onPromise(Promise.reject(error));
    } finally {
      setIsDownloadingCa(false);
    }
  };

  return (
    <Button
      variant="primary"
      onClick={handleDownloadCa}
      disabled={isDownloadingCa}
    >
      <Download className="me-2" />
      {isDownloadingCa ? 'Pobieranie...' : 'Pobierz certyfikat CA'}
    </Button>
  );
};
